// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___g-CM","right":"styles_right__3T504"};